import {
  listAllTransactionReport,
  GetTransactionListParams,
  listFamilyDetailReport,
  GetFamilyDetailListParams,
} from "services/reportService";

import {
  fetchTransactions,
  fetchFamilyDetails,
  setPagination,
  setReportLoader,
  reportSuccessMsg,
  reportErrorMsg,
} from "./reducer";

import { toast } from "react-toastify";

export const fetchTransactionReportThunk =
  (params: GetTransactionListParams) => async (dispatch: any) => {
    dispatch(setReportLoader(true));

    try {
      const response = await listAllTransactionReport(params);

      if (response?.success) {
        const transactions = response?.data?.transactions || [];
        const pagination = response?.data?.pagination || {};

        dispatch(
          fetchTransactions({
            transactions,
            pagination,
          })
        );
        dispatch(setPagination(pagination));
      } else {
        dispatch(
          reportErrorMsg({ message: response?.message, id: Date.now() })
        );
        toast.error(response?.message || "Failed to load transactions");
      }
    } catch (error: any) {
      const errorMessage =
        error?.message ||
        error?.response?.data?.message ||
        "Failed to load transactions";
      dispatch(reportErrorMsg({ message: errorMessage, id: Date.now() }));
      toast.error(errorMessage);
    } finally {
      dispatch(setReportLoader(false));
    }
  };

export const fetchFamilyDetailReportThunk =
  (params: GetFamilyDetailListParams) => async (dispatch: any) => {
    dispatch(setReportLoader(true));

    try {
      const response = await listFamilyDetailReport(params);

      if (response?.success) {
        const familydetails = response?.data?.familydetails || [];
        const pagination = response?.data?.pagination || {};

        dispatch(
          fetchFamilyDetails({
            familydetails,
            pagination,
          })
        );
        dispatch(setPagination(pagination));
      } else {
        dispatch(
          reportErrorMsg({ message: response?.message, id: Date.now() })
        );
        toast.error(response?.message || "Failed to load family details");
      }
    } catch (error: any) {
      const errorMessage =
        error?.message ||
        error?.response?.data?.message ||
        "Failed to load family details";
      dispatch(reportErrorMsg({ message: errorMessage, id: Date.now() }));
      toast.error(errorMessage);
    } finally {
      dispatch(setReportLoader(false));
    }
  };


